import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardActionArea, CardContent, CardMedia, Divider, List, ListItem, Stack, Typography } from '@mui/material';
import BuilderSelct from '@/store/builderStoreSelector';
import { BuilderProduct, BuilderProductType } from '@/store/builderSlice';
import ProductListView from './ProductListView';
import { useDispatch } from 'react-redux';
import { isProductTypeLoaded, loadBuilderProductsByType } from '@/store/builder/thunks/builderProductsLoader';


export default function ProductTray(props: { productType?: string, productId?: string, includeRecommendations?: boolean }) {
  const dispatch = useDispatch();
  const [curProductType, setCurProductType] = useState<string | undefined>(undefined);
  const products: BuilderProduct[] = BuilderSelct.productContent().products;
  const productTypes: BuilderProductType[] = BuilderSelct.productContent().productTypes;

  const onProductTypeSelected = useCallback((productType: string) => () => {
    if (!isProductTypeLoaded(productType)) {
      dispatch(loadBuilderProductsByType({ productType }) as any);
    }
    setCurProductType(productType);
  }, []);

  const closeProductsView = useCallback(() => () => {
    setCurProductType(undefined);
  }, []);

  useEffect(() => {
    if (props.productType && props.productType !== curProductType) {
      if (!isProductTypeLoaded(props.productType)) {
        dispatch(loadBuilderProductsByType({ productType: props.productType, productId: props.productId, includeRecommendations: props.includeRecommendations }) as any);
      }
      setCurProductType(props.productType);
    }

  }, [props.productType]);

  const productTypesView = () => {
    return <List sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto', width: '100%', maxWidth: 120, bgcolor: 'background.paper' }}>
      {productTypes.map((productType: BuilderProductType) => (
        <ListItem key={productType.productTypeId}>
          <Card id={productType.productTypeId}
            sx={{
              maxWidth: 200,
              //border: isActiveRoomModel ? '2px solid #DC7633' : ''
            }}>
            <CardActionArea onClick={onProductTypeSelected(productType.name)}>
              <Stack spacing={0} direction="column">
                <CardMedia
                  sx={{ width: '120px' }}
                  image={productType.imageUrl}
                  title={productType.displayName}
                />
                <CardContent
                  sx={{
                    maxWidth: '100%',
                  }}>
                  <Typography gutterBottom variant="h5" component="div">
                    {productType.displayName}
                  </Typography>
                </CardContent>
              </Stack>
            </CardActionArea>
          </Card>
        </ListItem>
      ))}
    </List>
  }

  const getProductListView = () => {
    const curProducts = curProductType === 'All_Products' ?
      products : curProductType === 'SingleProduct' ? products.filter(product => product.productId === props.productId) : products.filter(product => product.productTypeName === curProductType);
    const uniqueProducts = curProducts.filter((a, i) => curProducts.findIndex((s) => a.productId === s.productId) === i);
    return <>
      <ProductListView products={uniqueProducts!} closeProductsView={closeProductsView} maxHeight={617} />
      {props.includeRecommendations && uniqueProducts.length > 0 && (
        <>
          {uniqueProducts[0].similarProducts && uniqueProducts[0].similarProducts.length > 0 && (
            <>
              <Divider flexItem sx={{ borderRightWidth: 2, marginBottom: '5px', marginTop: '5px', borderColor: 'black' }} style={{ background: 'black' }} />
              <Typography gutterBottom variant="h5" component="div" fontWeight={'bold'}>
                Similar products
              </Typography>
              <div style={{ maxHeight: '250px', overflow: 'auto' }}>
                <ProductListView products={uniqueProducts[0].similarProducts!} closeProductsView={closeProductsView} maxHeight={200} />
              </div>
            </>
          )
          }
          {uniqueProducts[0].relatedProducts && uniqueProducts[0].relatedProducts.length > 0 && (
            <>
              <Divider sx={{ borderRightWidth: 2, marginBottom: '5px', marginTop: '5px', borderColor: 'black' }} style={{ background: 'black' }} />
              <Typography gutterBottom variant="h5" component="div" fontWeight={'bold'}>
                Related products
              </Typography>
              <div style={{ maxHeight: '250px', overflow: 'auto' }}>
                <ProductListView products={uniqueProducts[0].relatedProducts!} closeProductsView={closeProductsView} maxHeight={200} />
              </div>
            </>
          )}
        </>
      )}
    </>
  }

  return (
    <>
      {curProductType ? getProductListView() : productTypesView()}
    </>

  );
}